import React from 'react';
import { Check } from 'lucide-react';

const t = {
  en: {
    label: 'YOUR STRENGTH TRAINING',
    title: 'YOUR STRENGTH TRAINING — SCIENTIFICALLY OPTIMIZED',
    items: [
      'Progressive overload training for maximum muscle gains',
      'Individual strength programs from beginner to advanced',
      'Detailed training log and weight progression tracking',
      'Measurable strength and muscle gains in 8 weeks',
    ],
  },
  de: {
    label: 'DEIN KRAFTTRAINING',
    title: 'DEIN KRAFTTRAINING — WISSENSCHAFTLICH OPTIMIERT',
    items: [
      'Progressives Overload-Training für maximale Muskelzuwächse',
      'Individuelle Kraft-Programme für Anfänger bis Fortgeschrittene',
      'Detaillierte Trainingslog und Gewichtsfortschritt-Tracking',
      'In 8 Wochen messbare Kraft- und Muskelzuwächse',
    ],
  },
};

export default function TrainingGoals({ lang }) {
  const tx = t[lang];

  return (
    <section className="py-24 px-6" style={{ backgroundColor: '#0f1117' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left: Text content */}
          <div>
            <p
              className="text-sm font-bold uppercase mb-4"
              style={{ color: '#3b82f6', letterSpacing: '0.2em' }}
            >
              {tx.label}
            </p>
            <h2
              className="font-black uppercase leading-tight mb-12"
              style={{
                fontSize: 'clamp(1.8rem, 4vw, 3rem)',
                letterSpacing: '-0.02em',
                color: '#ffffff',
              }}
            >
              {tx.title}
            </h2>

            <ul className="space-y-5">
              {tx.items.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div
                    className="flex-shrink-0 flex items-center justify-center rounded-full mt-0.5"
                    style={{
                      width: 28,
                      height: 28,
                      background: 'linear-gradient(135deg, #3b82f6, #06b6d4)',
                    }}
                  >
                    <Check size={15} color="#ffffff" strokeWidth={3} />
                  </div>
                  <span
                    className="leading-relaxed font-medium"
                    style={{ color: '#cbd5e1', fontSize: '1.05rem' }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Visual accent panel */}
          <div className="relative hidden md:block">
            <div
              className="rounded-2xl overflow-hidden"
              style={{
                background: 'linear-gradient(135deg, #1a1d27 0%, #0f1117 100%)',
                border: '1px solid rgba(59,130,246,0.2)',
                padding: '2.5rem',
              }}
            >
              {/* Big stat */}
              <div className="mb-8">
                <div
                  className="font-black"
                  style={{ fontSize: '5rem', color: '#3b82f6', lineHeight: 1, letterSpacing: '-0.04em' }}
                >
                  100%
                </div>
                <div
                  className="font-bold uppercase mt-2"
                  style={{ color: '#94a3b8', letterSpacing: '0.15em', fontSize: '0.85rem' }}
                >
                  {lang === 'de' ? 'Personalisiert' : 'Personalized'}
                </div>
              </div>

              <div
                className="h-px w-full mb-8"
                style={{ background: 'linear-gradient(to right, #3b82f6, transparent)' }}
              />

              {/* Mini stats */}
              <div className="grid grid-cols-2 gap-6">
                {[
                  { val: '500+', label: lang === 'de' ? 'Workouts' : 'Workouts' },
                  { val: '24/7', label: lang === 'de' ? 'Verfügbar' : 'Available' },
                  { val: '10k+', label: lang === 'de' ? 'Nutzer' : 'Users' },
                  { val: '4.9★', label: lang === 'de' ? 'Bewertung' : 'Rating' },
                ].map((stat, i) => (
                  <div key={i}>
                    <div
                      className="font-black"
                      style={{ fontSize: '1.75rem', color: '#ffffff', letterSpacing: '-0.02em' }}
                    >
                      {stat.val}
                    </div>
                    <div
                      className="text-xs font-semibold uppercase mt-0.5"
                      style={{ color: '#64748b', letterSpacing: '0.1em' }}
                    >
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>

              {/* Blue glow */}
              <div
                className="absolute -bottom-10 -right-10 rounded-full pointer-events-none"
                style={{
                  width: 200,
                  height: 200,
                  background: 'radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
